import React, { useState, useEffect } from 'react';
import { CheckCircle, Server, Zap, Shield, Globe, ChevronLeft, ChevronRight } from 'lucide-react';
import { getStorageUrl } from '../utils/imageUrlUpdater';

const VPSCanada: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentGallerySlide, setCurrentGallerySlide] = useState(0);

  // Set page title and canonical URL
  useEffect(() => {
    document.title = 'VPS Canada - VMon Cloud';
    
    // Set canonical URL
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = 'https://vmon.vn/vps-canada';
    document.head.appendChild(canonical);
    
    return () => {
      if (canonical.parentNode) {
        canonical.parentNode.removeChild(canonical);
      }
      document.title = 'VMon Cloud - Dịch vụ VPS và Hosting chất lượng cao';
    };
  }, []);

  const plans = [
    {
      name: 'VPS Basic CA',
      price: '115,000',
      originalPrice: '150,000',
      cpu: '1 VCpu',
      ram: '1GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Standard CA',
      price: '155,000',
      originalPrice: '200,000',
      cpu: '1 VCpu',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Premium CA',
      price: '175,000',
      originalPrice: '250,000',
      cpu: '2 VCpu',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: true
    },
    {
      name: 'VPS Enterprise CA',
      price: '315,000',
      originalPrice: '415,000',
      cpu: '2 VCpu',
      ram: '4GB',
      storage: '60GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: true
    },
    {
      name: 'VPS Pro CA',
      price: '575,000',
      originalPrice: '800,000',
      cpu: '4 VCpu',
      ram: '8GB',
      storage: '100GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Ultimate CA',
      price: '915,000',
      originalPrice: '1,500,000',
      cpu: '8 VCpu',
      ram: '16GB',
      storage: '180GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    }
  ];

  const specifications = [
    { label: 'Datacenter', value: 'Toronto, Vancouver' },
    { label: 'Network', value: '1Gbps Port Speed' },
    { label: 'Storage', value: '100% SSD NVMe' },
    { label: 'Virtualization', value: 'KVM' },
    { label: 'Control Panel', value: 'VMon' },
    { label: 'Setup Time', value: 'Instant' },
    { label: 'IPv4', value: '1 Dedicated IP' },
    { label: 'Backup', value: 'Weekly Automatic' }
  ];

  const additionalPricing = [
    { item: '1 IP', price: '50,000 VNĐ / Tháng' },
    { item: '1 VCpu', price: '50,000 VNĐ / Tháng' },
    { item: '1 GB Ram', price: '50,000 VNĐ / Tháng' },
    { item: '10GB ổ cứng SSD NVMe', price: '30,000 VNĐ / Tháng' }
  ];

  const advantages = [
    {
      icon: Server,
      title: 'VPS CANADA VỚI KHẢ NĂNG MỞ RỘNG',
      description: 'VMon Cloud cung cấp các giải pháp hoàn toàn có thể mở rộng. Bạn có thể nâng cấp VPS của mình bất kỳ lúc nào khi doanh nghiệp của bạn phát triển.'
    },
    {
      icon: Shield,
      title: 'MIỄN PHÍ DDOS 100%',
      description: 'Khi có những nguy cơ xâm nhập, tấn công vào tài nguyên hay dữ liệu của bạn, chúng tôi sẽ chống lại những cuộc tấn công đó giúp bạn, và hoàn toàn miễn phí.'
    },
    {
      icon: Zap,
      title: 'DỮ LIỆU ĐƯỢC SAO LƯU HÀNG TUẦN AN TOÀN',
      description: 'Giờ đây, bạn không cần phải lo lắng về việc mất dữ liệu, VMon Cloud sẽ giúp bạn backup (sao lưu) hàng tuần.'
    },
    {
      icon: Globe,
      title: 'ĐA DẠNG, HỖ TRỢ NHIỀU HỆ ĐIỀU HÀNH',
      description: 'VPS Canada có thể sử dụng đa dạng hệ điều hành: Windows 10, Windows Server 2012r2, Windows Server 2016, Windows server 2019, Windows Server 2022 và các hệ điều hành linux khác.'
    }
  ];

  const benefits = [
    {
      icon: Server,
      title: 'UNLIMITED DATA TRANSFER',
      description: 'Dịch vụ VPS Canada của VMon Cloud không bị giới hạn lượng Data Transfer. Vì vậy bạn hoàn toàn không cần lo lắng về việc dữ liệu trao đổi bị giới hạn ảnh hưởng đến hiệu suất làm việc của doanh nghiệp.'
    },
    {
      icon: Shield,
      title: 'HOÀN TIỀN 100% NẾU KHÔNG HÀI LÒNG',
      description: 'Chúng tôi cam kết hoàn tiền theo chính sách nếu khách hàng không hài lòng với dịch vụ VPS Canada. Thời gian hoàn tiền được thực hiện nhanh chóng.'
    },
    {
      icon: Zap,
      title: 'TOÀN QUYỀN QUẢN TRỊ CẤP CAO NHẤT',
      description: 'Với VPS Canada bạn có toàn quyền Administrator cao nhất! Bạn có thể chủ động và toàn quyền trong thao tác, kiểm soát hoạt động của máy chủ thông qua trang quản trị rõ ràng, dễ hiểu và đặc biệt đầy đủ tính năng.'
    },
    {
      icon: Globe,
      title: 'HỖ TRỢ NHIỆT TÌNH 24/7',
      description: 'Đội ngũ kỹ thuật viên của chúng tôi thường trực 24/7 để hỗ trợ bạn, giải quyết vấn đề một cách nhanh chóng, không làm ảnh hưởng đến hoạt động kinh doanh.'
    }
  ];

  const faqItems = [
    {
      question: 'VPS Canada là gì?',
      answer: 'VPS Canada có máy chủ đặt tại Canada, nơi có cơ sở hạ tầng bảo mật dữ liệu hàng đầu, vì vậy bạn không phải lo lắng về việc mất hoặc bị đánh cắp dữ liệu của mình.'
    },
    {
      question: 'Việc cấp phép VPS mất bao lâu?',
      answer: 'VPS của bạn sẽ được cấp phép trong vòng 15 phút, nhưng trong một số trường hợp, vui lòng đợi tối đa 2 giờ. Vui lòng đảm bảo thông tin thanh toán của bạn là chính xác, nếu không, việc cấp phép có thể bị trì hoãn bởi hệ thống chống gian lận của chúng tôi. Nếu bạn không nhận được email sau khi thanh toán, vui lòng kiểm tra thư mục thư rác của bạn.'
    },
    {
      question: 'Làm sao để sử dụng VPS Canada trên máy tính?',
      answer: 'Sau khi mua VPS Canada hay bất kỳ VPS nào, quý khách có thể sử dụng VPS trên máy tính thông qua ứng dụng Remote Desktop Connection có sẵn trên máy tính, chỉ cần mở ứng dụng lên, điền IP, Username và Password vào là có thể đăng nhập và sử dụng VPS. Ngoài ra, bạn cũng có thể sử dụng VPS trên điện thoại tương tự như trên máy tính.'
    },
    {
      question: 'Tôi có thể nâng cấp tài nguyên khi mua VPS Canada không?',
      answer: 'Hoàn toàn có thể! Bạn có thể chọn một gói cao hơn để đáp ứng nhu cầu tăng trưởng, chỉ bằng vài cú click chuột, tất cả đều được tự động, an toàn mà lại cực kỳ hiệu quả.'
    },
    {
      question: 'VPS Canada sử dụng IP riêng hay chung?',
      answer: 'Tại VMon Cloud, mỗi VPS Canada đều được cấp 1 IP riêng biệt, không chia sẻ với người dùng khác.'
    },
    {
      question: 'Tôi có thể thanh toán qua hình thức nào khi mua VPS Canada?',
      answer: 'Bạn có thể thanh toán qua chuyển khoản ngân hàng, Ví điện tử Momo, Paypal. Các tài khoản ngân hàng Vietcombank, Techcombank.'
    }
  ];

  const testimonials = [
    getStorageUrl('feedback/feedback_1.jpg'),
    getStorageUrl('feedback/feedback_2.jpg'),
    getStorageUrl('feedback/feedback_3.jpg'),
    getStorageUrl('feedback/feedback_4.jpg'),
    getStorageUrl('feedback/feedback_5.jpg'),
    getStorageUrl('feedback/feedback12.jpg'),
    getStorageUrl('feedback/feedback16.jpg'),
    getStorageUrl('feedback/feedback17.jpg')
  ];

  const galleryImages = [
    {
      src: getStorageUrl('panel/quan-ly-hoa-don.PNG'),
      title: "Quản Lý Hoá Đơn",
      description: "Quản lý hoá đơn mua vps đầy đủ và minh bạch."
    },
    {
      src: getStorageUrl('panel/View-VNC.PNG'),
      title: "View VPS qua VNC",
      description: "Truy cập xử lý sự cố vps thông qua VNC."
    },
    {
      src: getStorageUrl('panel/Mua-VPS.PNG'),
      title: "MUA VPS",
      description: "Mua VPS Canada thuận tiện với giao diện one click."
    },
    {
      src: getStorageUrl('panel/giao-dien-mobile.PNG'),
      title: "Giao Diện Mobile",
      description: "Giao diện mobile thân thiện, dễ quản lý."
    },
    {
      src: getStorageUrl('panel/lich-su-so-du.PNG'),
      title: "Số Dư Tài Khoản",
      description: "Quản lý số dư tài khoản thuận tiện và minh bạch."
    },
    {
      src: getStorageUrl('panel/cai-lai-he-dieu-hanh.PNG'),
      title: "Cài Đặt Lại Hệ Điều Hành",
      description: "Cài đặt lại hệ điều hành tự động và nhanh chóng. Hỗ trợ đủ os: windows và linux."
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextGallerySlide = () => {
    setCurrentGallerySlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevGallerySlide = () => {
    setCurrentGallerySlide((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4">
              <Globe className="h-8 w-8 mr-2" />
              <span className="text-2xl font-semibold">VPS Canada</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              VPS Canada
            </h1>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Mua VPS Canada nền tảng mạnh mẽ, SSD Siêu tốc, công nghệ ảo hóa KVM, 
              không giới hạn Data Transfer. Giá ưu đãi 115.000đ/tháng.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Zap className="h-4 w-4 mr-2" />
                Tốc độ cao
              </div>
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Shield className="h-4 w-4 mr-2" />
                100% SSD NVMe
              </div>
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Server className="h-4 w-4 mr-2" />
                99.9% Uptime
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">BẢNG GIÁ CLOUD VPS CANADA</h2>
            </div>
          {/* Alert */}
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-8 rounded">
            <p className="font-bold">Ưu đãi hấp dẫn giảm ngay 40% khi gia hạn 3 năm.</p>
            <p>Giảm 20% khi gia hạn 1 năm, giảm 10% khi gia hạn 6 tháng, giảm 5% khi gia hạn 3 tháng.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {plans.slice(0, 3).map((plan, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105 ${
                  plan.popular ? 'ring-2 ring-blue-500' : ''
                }`}
              >
                {plan.popular && (
                  <div className="bg-blue-500 text-white text-center py-2 font-semibold">
                    BÁN CHẠY
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <div className="mb-4">
                    <div className="flex items-baseline">
                      <span className="text-3xl font-bold text-blue-600">{plan.price}</span>
                      <span className="text-gray-600 ml-1"> VNĐ/Tháng</span>
                    </div>
                    <div className="text-sm text-gray-500 line-through">{plan.originalPrice} VNĐ</div>
                  </div>

                  <div className="space-y-3 mb-6">
                    <div className="flex justify-between">
                      <span className="text-gray-600">CPU:</span>
                      <span className="font-semibold">{plan.cpu}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">RAM:</span>
                      <span className="font-semibold">{plan.ram}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Storage:</span>
                      <span className="font-semibold">{plan.storage}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Bandwidth:</span>
                      <span className="font-semibold">{plan.bandwidth}</span>
                    </div>
                  </div>

                  <ul className="space-y-2 mb-6">
                    {plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm">
                        <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <a 
                    href="https://cloud.vmon.vn/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-full py-3 rounded-lg font-semibold transition-colors flex items-center justify-center ${
                      plan.popular
                        ? 'bg-blue-600 text-white hover:bg-blue-700'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    Đăng Ký
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            {plans.slice(3, 6).map((plan, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105 ${
                  plan.popular ? 'ring-2 ring-blue-500' : ''
                }`}
              >
                {plan.popular && (
                  <div className="bg-blue-500 text-white text-center py-2 font-semibold">
                    BÁN CHẠY
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <div className="mb-4">
                    <div className="flex items-baseline">
                      <span className="text-3xl font-bold text-blue-600">{plan.price}</span>
                      <span className="text-gray-600 ml-1"> VNĐ/Tháng</span>
                    </div>
                    <div className="text-sm text-gray-500 line-through">{plan.originalPrice} VNĐ</div>
                  </div>

                  <div className="space-y-3 mb-6">
                    <div className="flex justify-between">
                      <span className="text-gray-600">CPU:</span>
                      <span className="font-semibold">{plan.cpu}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">RAM:</span>
                      <span className="font-semibold">{plan.ram}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Storage:</span>
                      <span className="font-semibold">{plan.storage}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Bandwidth:</span>
                      <span className="font-semibold">{plan.bandwidth}</span>
                    </div>
                  </div>

                  <ul className="space-y-2 mb-6">
                    {plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm">
                        <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <a 
                    href="https://cloud.vmon.vn/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-full py-3 rounded-lg font-semibold transition-colors flex items-center justify-center ${
                      plan.popular
                        ? 'bg-blue-600 text-white hover:bg-blue-700'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    Đăng Ký
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Pricing */}
          <div className="mt-12 bg-white rounded-lg shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              Bảng Giá Đăng Ký Thêm CPU, RAM, Ổ Cứng, IP
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {additionalPricing.map((item, index) => (
                <div key={index} className="text-center p-4 border border-gray-200 rounded-lg">
                  <div className="flex items-center justify-center mb-2">
                    <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                    <span className="font-semibold text-gray-900">{item.item}</span>
                  </div>
                  <p className="text-blue-600 font-medium">{item.price}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              NHỮNG ƯU ĐIỂM VƯỢT TRỘI CỦA CLOUD VPS CANADA TẠI VMon Cloud
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((advantage, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <advantage.icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{advantage.title}</h3>
                <p className="text-gray-600 text-sm">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              LỢI ÍCH KHI MUA VPS CANADA GIÁ RẺ TẠI VMon Cloud
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <benefit.icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Feedback Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">KHÁCH HÀNG NÓI GÌ VỀ CHÚNG TÔI?</h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              Với chúng tôi, ý kiến của khách hàng là rất quan trọng. Chúng tôi luôn lắng nghe và tiếp thu phản hồi để cải thiện sản phẩm và dịch vụ, phiên dịch trở nên tốt hơn. Điều này giúp chúng tôi đáp ứng tốt hơn nhu cầu và mong muốn của khách hàng để mang đến sự hài lòng và tin tưởng cao nhất.
            </p>
          </div>

          {/* Testimonial Slider */}
          <div className="relative max-w-4xl mx-auto">
            {/* Main Slider */}
            <div className="relative overflow-hidden rounded-lg shadow-lg bg-white">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="w-full flex-shrink-0 flex justify-center items-center p-4">
                    <img
                      src={testimonial}
                      alt={`Customer Feedback ${index + 1}`}
                      className="max-w-full max-h-96 object-contain rounded-lg shadow-sm"
                    />
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-200"
              >
                <ChevronLeft className="h-6 w-6 text-gray-700" />
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-200"
              >
                <ChevronRight className="h-6 w-6 text-gray-700" />
              </button>
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-200 ${
                    index === currentSlide 
                      ? 'bg-blue-600 scale-110' 
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Thư Viện Hình Ảnh</h2>
          <p className="text-lg text-gray-600 mb-12 text-center">
            Quản lý tài khoản, tạo mới và giám sát vps dễ dàng với trang panel hiện đại, thân thiện dễ sử dụng.
          </p>
          
          {/* Gallery Slider */}
          <div className="relative max-w-4xl mx-auto">
            <div className="overflow-hidden rounded-lg bg-gray-100">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentGallerySlide * 100}%)` }}
              >
                {galleryImages.map((image, index) => (
                  <div key={index} className="w-full flex-shrink-0 p-8">
                    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                      <img
                        src={image.src}
                        alt={image.title}
                        className="w-full h-64 object-contain bg-gray-50"
                      />
                      <div className="p-6 text-center">
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{image.title}</h3>
                        <p className="text-gray-600">{image.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation Buttons */}
            <button
              onClick={prevGallerySlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronLeft className="h-6 w-6 text-gray-600" />
            </button>
            <button
              onClick={nextGallerySlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronRight className="h-6 w-6 text-gray-600" />
            </button>
            
            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 space-x-2">
              {galleryImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentGallerySlide(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    index === currentGallerySlide ? 'bg-blue-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Specifications Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Thông Số Kỹ Thuật</h2>
            <p className="text-lg text-gray-600">Chi tiết cấu hình và tính năng</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {specifications.map((spec, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-4">
                <div className="text-sm text-gray-600 mb-1">{spec.label}</div>
                <div className="font-semibold text-gray-900">{spec.value}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Canada VPS */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Tại Sao Chọn VPS Canada?</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Zap className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Vị trí địa lý tốt</h3>
              <p className="text-gray-600">
                Canada có vị trí địa lý thuận lợi, kết nối tốt với cả Mỹ và châu Âu
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Luật bảo mật nghiêm ngặt</h3>
              <p className="text-gray-600">
                Canada có luật bảo vệ dữ liệu nghiêm ngặt, đảm bảo an toàn thông tin
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Server className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hạ tầng hiện đại</h3>
              <p className="text-gray-600">
                Datacenter với công nghệ tiên tiến và nguồn điện ổn định
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Những câu hỏi thường gặp về máy chủ ảo VPS Canada
            </h2>
          </div>

          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <details key={index} className="bg-white rounded-lg p-6 shadow">
                <summary className="font-semibold text-gray-900 cursor-pointer hover:text-blue-600">
                  {item.question}
                </summary>
                <p className="mt-4 text-gray-600">{item.answer}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Cùng nhau, Trực tuyến.
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Chúng tôi ở đây giúp các bạn có thể làm việc online một cách hiệu quả nhất.
          </p>
          <a 
            href="https://cloud.vmon.vn/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors inline-block"
          >
            Bắt đầu ngay
          </a>
        </div>
      </section>
    </div>
  );
};

export default VPSCanada;